import { isNotDefined, getMACalculator, getSourcePathAccessor } from "../utils";
import { Disparity as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize, sourcePath, movingAverageType } = options;

    const source = getSourcePathAccessor(sourcePath);

    // Get MA calculator using centralized utility
    const maCalculator = getMACalculator(movingAverageType);

    // Calculate MA values
    const maValues = maCalculator().options({ windowSize, sourcePath })(data);

    // Calculate Disparity Index: 100 * (Price / MA - 1)
    const disparityValues = data.map((d, i) => {
      const value = source(d);
      const ma = maValues[i];

      if (isNotDefined(value) || isNotDefined(ma) || ma === 0) {
        return undefined;
      }

      // Disparity Index formula from ChartIQ: 100 * (Price / MA - 1)
      const disparity = 100 * (value / ma - 1);

      return disparity;
    });

    return disparityValues;
  }

  calculator.undefinedLength = function () {
    return options.windowSize - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
